import { bannersQueries } from '~/services/queries'

const ADMIN_FORM_KEY = 'admin/form'

export const useBanners = () => {
  const state = useState('banners', () => ({
    isLoading: false,
    items: [] as Record<string, unknown>[],
    item: {} as Record<string, unknown>,
    bannersByCity: {} as Record<string | number, Record<string, unknown>[]>,
  }))

  const items = computed(() => state.value.items)
  const item = computed(() => state.value.item)
  const isLoading = computed(() => state.value.isLoading)

  const getBannersByCity = (cityId: string | number) => {
    return state.value.bannersByCity[cityId] || []
  }

  const fetchBannersForAdmin = async () => {
    useStoreFields().startSubmitting(ADMIN_FORM_KEY)
    state.value.isLoading = true
    try {
      const { $gql } = useNuxtApp()
      const { result } = await $gql.request(bannersQueries.bannersForAdmin)
      state.value.items = result || []
    } catch (error) {
      console.error('Ошибка при загрузке баннеров для админки:', error)
      state.value.items = []
    }
    state.value.isLoading = false
    useStoreFields().finishSubmitting(ADMIN_FORM_KEY)
  }

  const fetchBanners = async ({ cityId }: { cityId: string | number }) => {
    if (state.value.bannersByCity[cityId]) {
      state.value.items = state.value.bannersByCity[cityId]
      return
    }

    state.value.isLoading = true
    try {
      const { $gql } = useNuxtApp()
      const { result } = await $gql.request(bannersQueries.banners, { cityId })
      const banners = result || []
      state.value.items = banners
      state.value.bannersByCity[cityId] = banners
    } catch (error) {
      console.error('Ошибка при загрузке баннеров:', error)
      state.value.items = []
      state.value.bannersByCity[cityId] = []
    }
    state.value.isLoading = false
  }

  const bannerCreate = async ({ params, image440, image1024, image1368 }) => {
    useStoreFields().startSubmitting(ADMIN_FORM_KEY)
    state.value.isLoading = true
    const { $gql } = useNuxtApp()
    const { result } = await $gql.request(bannersQueries.bannerCreate, {
      params,
      image440,
      image1024,
      image1368,
    })
    state.value.isLoading = false
    useStoreFields().finishSubmitting(ADMIN_FORM_KEY)
    return result
  }

  const bannerUpdateImage = async ({ id, image, imageResolution }) => {
    state.value.isLoading = true
    const { $gql } = useNuxtApp()
    const { result } = await $gql.request(bannersQueries.bannerUpdateImage, {
      id,
      image,
      imageResolution,
    })
    state.value.isLoading = false
    return result
  }

  const bannerUpdate = async ({ id, params }) => {
    useStoreFields().startSubmitting(ADMIN_FORM_KEY)
    state.value.isLoading = true
    const { $gql } = useNuxtApp()
    const { result } = await $gql.request(bannersQueries.bannerUpdate, {
      id,
      params,
    })
    state.value.isLoading = false
    useStoreFields().finishSubmitting(ADMIN_FORM_KEY)
    return result
  }

  return {
    items,
    item,
    isLoading,
    getBannersByCity,
    fetchBannersForAdmin,
    fetchBanners,
    bannerCreate,
    bannerUpdateImage,
    bannerUpdate,
  }
}
